import { useDispatch, useSelector } from "react-redux"
import { appdataSelector } from "reducers/appdata/appdata"
import { vendordataSelector, vendordata_setBanksFromSearch, vendordata_updateActiveVendor } from "reducers/vendordata/vendordata"
import { formatData } from "./VendordataHelper"
import VendordataEditableBankSearch from "./VendordataEditableBankSearch";
import React, { useEffect, useState } from "react";
import { Card } from "@mui/material";
import Button from "@mui/material/Button";
import classnames from "classnames";


function VendordataEditableBank() {
    console.log("VendordataEditableBank VendordataEditableBank")
    const vendordata = useSelector(vendordataSelector);
    const appdata = useSelector(appdataSelector);
    const dispatch = useDispatch();
    const [showBankSearch, setShowBankSearch] = useState(false)
    const [numberOfBanks, setNumberOfBanks] = useState(0);
    const inputWidth = "100%";
    const styles = {
        myInput: {
            width: inputWidth
        },
        mySelect: {
            height: 30,
            width: inputWidth
        }
    };

    useEffect(() => {
        console.log("new vendordataeditablebank", Object.keys(vendordata.activeVendor.BANK[0]).length)
        if (!vendordata.activeVendor.BANK) {
            if (!showBankSearch)
                setShowBankSearch(true);
        }

        if (vendordata.activeVendor.BANK && Object.keys(vendordata.activeVendor.BANK[0]).length == 1) {
            console.log("got bank")
            if (!showBankSearch) {
                console.log("should set")
                setShowBankSearch(true);
            }
        }
    }, [])

    useEffect(() => {
        if (numberOfBanks < Object.keys(vendordata.activeVendor.BANK).length && Object.keys(vendordata.activeVendor.BANK[0]).length > 1) {
            if (showBankSearch)
                setShowBankSearch(false)
            setNumberOfBanks(Object.keys(vendordata.activeVendor.BANK).length)
        }
    }, [vendordata.activeVendor.BANK])


    let datapart = { ...vendordata.vendorParts.BANK }
    let data = {};



    if (vendordata.activeVendor.BANK && Object.keys(vendordata.activeVendor.BANK[0]).length > 1) {
        data = formatData("BANK", datapart, appdata, vendordata);
    }

    const handleChange = (value, key, id) => {
        dispatch(
            vendordata_updateActiveVendor({
                part: "BANK",
                key: key,
                id: id,
                value: value
            })
        );
    };

    const handleRemoveBank = (SEQ) => {
        let id = null;
        Object.keys(vendordata.activeVendor.BANK).map((key, value) => {
            if (vendordata.activeVendor.BANK[key]["SEQ"] == SEQ) {
                id = key;
            }
        });

        if (id)
            handleChange("X", "REMOVE", id);

    }

    const handleAddBank = () => {
        
        
        dispatch(vendordata_setBanksFromSearch({}))

        if (!showBankSearch) {
            setShowBankSearch(true);
        }
    }


    console.log("before render", showBankSearch)
    return (

        <div>
            {/* cards with contact */}
            {/* cards with contact */}
            {/* cards with contact */}
            {/* cards with contact */}
            {/* cards with contact */}
            {Object.keys(data).map(key => {
                let fields = data[key].item;

                return (

                    <Card className={data[key].DELETED ? "p-4 mt-2 bg-danger" : data[key].REMOVE ? "p-4 mt-2 bg-warning" : "p-4 mt-2"}
                        key={"Card" + key}
                        style={{ pointerEvents: data[key].REMOVE || data[key].DELETED ? "none" : "" }} >
                        {/* header */}
                        {/* header */}
                        {/* header */}
                        {/* header */}
                        <div className="row border-bottom mb-2 pb-2">
                            <div className="col-3 d-none d-md-block">Label</div>
                            <div className="col-6 col-md-4">New value</div>
                            {appdata.activeRequestType != "NV" && (
                                <div className="col-6 col-md-5">Original value</div>
                            )}
                        </div>

                        {/* show fields */}
                        {/* show fields */}
                        {/* show fields */}
                        {/* show fields */}
                        {Object.keys(fields).map(fieldkey => {
                            let highlight = false;
                            if (appdata.highlightRequiredFields) {
                                if (vendordata.incompleteRequiredFields.hasOwnProperty("BANK") && Object.keys(vendordata.incompleteRequiredFields["BANK"]).includes(key)) {
                                    if (vendordata.incompleteRequiredFields.BANK[key].includes(fieldkey)) {
                                        highlight = true;
                                    }
                                }
                            }
                            let highlightInfo = false;
                            if (appdata.activeRequestType != "NV") {
                                if (fields[fieldkey].active != fields[fieldkey].sap && (fields[fieldkey].active || fields[fieldkey].sap)) {
                                    highlightInfo = true;
                                }
                            }

                            let cls = "row mt-1 mb-1";

                            if (highlight){
                                cls += " border border-danger"
                            }
                            if (!highlight && highlightInfo){
                                cls += " border border-info"
                            }

                            let typeIsDropdown = fields[fieldkey].hasOwnProperty("key") ? true : false;
                            if (fields[fieldkey].hidden)
                                return
                            return (
                                <div className={cls} key={"rowpart" + fieldkey} >
                                    <div className="col-3 d-none d-md-flex align-items-center" key={"label" + fieldkey}>
                                        <b>
                                            {fields[fieldkey].label} {fields[fieldkey].required ? "*" : ""}
                                        </b>
                                    </div>



                                    {typeIsDropdown && (
                                        <div className="col-6 col-md-4" key={"dropdown" + key}>
                                            {" "}
                                            <select
                                                /* disabled={disabled} */
                                                key={key + "selection"}
                                                /* id={selectkey} */
                                                /* name={seltype + "selection"} */
                                                className="d-print-none"
                                                style={styles.mySelect}
                                                onChange={event => {
                                                    //props.handleSelect(event, part);
                                                    handleChange(
                                                        event.target.value,
                                                        fieldkey,
                                                        key);
                                                }}
                                                value={fields[fieldkey].value}
                                            >
                                                <option hidden></option>
                                                {fields[fieldkey].list &&
                                                    fields[fieldkey].list.map((item, keyIntern) => {
                                                        return (
                                                            <option
                                                                key={fieldkey + "_option" + keyIntern}
                                                                value={item[fields[fieldkey].listKeys[0]]}
                                                            >
                                                                {item[fields[fieldkey].listKeys[0]] +
                                                                    " - " +
                                                                    item[fields[fieldkey].listKeys[1]]}
                                                            </option>
                                                        );
                                                    })}
                                            </select>
                                        </div>
                                    )}
                                    {!typeIsDropdown && (
                                        <div className="col-6 col-md-4" key={"active" + fieldkey}>
                                            <input
                                                disabled={false}
                                                style={styles.myInput}
                                                onChange={event => {
                                                    handleChange(
                                                        event.target.value,
                                                        fieldkey,
                                                        key
                                                    );
                                                }}
                                                /* hidden={hidden} */
                                                key={"input" + fieldkey}
                                                /* id={key} */
                                                type="text"
                                                value={fields[fieldkey].active ? fields[fieldkey].active : ""}
                                            /* maxLength={maxChars ? maxChars : null} */
                                            ></input>

                                        </div>
                                    )}
                                    <div className="col-6 col-md-5 d-flex align-items-center" style={{ textDecoration: highlightInfo ? "line-through" : "" }}>{fields[fieldkey].sap}</div>
                                </div>
                            )
                        })}

                        <div className="text-right w-100">

                            {(data[key].REMOVE || data[key].DELETED) && (
                                <b>This bank {data[key].DELETED ? "has been" : "will be"} removed</b>

                            )}

                            {!data[key].REMOVE && !data[key].DELETED && (


                                <Button
                                    className={classnames("besiButton", "d-print-none")}
                                    variant="contained"
                                    key={key + "removebutton"}
                                    onClick={() => handleRemoveBank(data[key]["SEQ"])}
                                >
                                    remove
                                </Button>
                            )}

                        </div>


                    </Card>)
            })}

            {/* add bank button */}
            {/* add bank button */}
            {/* add bank button */}
            {/* add bank button */}
            {!showBankSearch && (
                < div key="addcontact buttondiv" >
                    <Button
                        className={classnames("besiButton", "d-print-none", "mt-2")}
                        variant="contained"
                        key="addcontactbutton1"
                        onClick={() => handleAddBank()}
                    >
                        Add Bank
                    </Button>
                </div >
            )}

            {/* end cards with content */}
            {/* end cards with content */}
            {/* end cards with content */}
            {/* end cards with content */}
            {/* end cards with content */}

            {showBankSearch && (
                <div key="searchdiv">
                    <VendordataEditableBankSearch></VendordataEditableBankSearch>
                </div>
            )}
        </div>
    )
}

export default VendordataEditableBank